/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { BrowserRouter } from "react-router-dom";
import awsConfig from "./awsConfig";
import Amplify from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react";
import { AuthProps } from "aws-amplify-react/props";
import { ApolloProvider } from "@apollo/react-hooks";
import { Container } from "semantic-ui-react";
import LoadIndicator from "./components/LoadIndicator";
import { LandingPageWrapper } from "./components/Authenticator";
import { Home } from "./components/Home";
import { apolloClient } from "./services/backend";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Logout from "./components/Home/Logout";
import styles from "./App.module.css";

Amplify.configure(awsConfig);

const authenticatorComponents = [
  <LandingPageWrapper key="LandingPageWrapper" />,
  <LoadIndicator override={"Loading"} key="LoadIndicator" />,
];

const App: React.FC<AuthProps> = (props) => {
  try {
    if (!props.authData.signInUserSession.idToken.payload.email_verified) {
      return <Logout />;
    }
  } catch {
    return <Logout />;
  }

  return (
    <ApolloProvider client={apolloClient}>
      <Container fluid id={styles.appContainer}>
        <BrowserRouter>
          <div className={styles.menuPlaceholder}></div>
          <Menu
            userId={
              props.authData.signInUserSession.idToken.payload["custom:uid"]
            }
          />
          <Home {...props} />
        </BrowserRouter>
      </Container>
      <Footer />
    </ApolloProvider>
  );
};

export default withAuthenticator(App, false, authenticatorComponents);
